/*
 * @Author: lisl27
 * @Date: 2021-11-29 15:31:44
 * @LastEditors: lisl27
 * @LastEditTime: 2021-11-29 17:54:01
 * @Description: file content
 */
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { Utils } from '../../helpers';
import { BasesController } from '../bases';

export class BiddingDetailController extends BasesController<any> {
  constructor(public CommonController) {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.business_getBusBiddingDetail,
      detailsParams: {
        valueGetter: this.valueGetter,
      },
    });
  }

  async parseCodeData(response) {
    const {
      customerInfo: { agentPosition },
      winRate,
    } = response;
    await this.CommonController.onGetwinRateList();
    await this.CommonController.onGetAagentPositionList();

    const curAgentPosition =
      lodash.find(this.CommonController.agentPositionList, (item) => {
        return item.value == agentPosition;
      }) || {};
    const curWinRate =
      lodash.find(this.CommonController.winRateList, (item) => {
        return item.value == winRate;
      }) || {};
    return { agentPosition: curAgentPosition.label, winRate: curWinRate.label };
  }

  valueGetter = async (response, AjaxConfig) => {
    const {
      reportProvinceName,
      reportCityName,
      biddingProductDetailParamList,
      budget,
      customerInfo: { provinceName, cityName },
    } = response;
    const codeData = await this.parseCodeData(response);

    const totalPrice = lodash.sumBy(
      biddingProductDetailParamList,
      (item: any) => {
        return item.productPrice * item.productNumber;
      },
    );
    const totalNumber = lodash.sumBy(
      biddingProductDetailParamList,
      (item: any) => {
        return parseInt(item.productNumber);
      },
    );
    lodash.assign(response, {
      _busInfo: lodash.assign({}, response, {
        _budget: budget ? Utils.currency(budget) : '',
        addressName: reportProvinceName
          ? `${reportProvinceName}${reportCityName}`
          : '',
        cAddressName: provinceName ? `${provinceName}${cityName}` : '',
        _agentPosition: codeData.agentPosition,
        _winRate: codeData.winRate,
      }),
      _productList: biddingProductDetailParamList,
      totalPrice: totalPrice.toFixed(2),
      totalNumber: totalNumber,
    });
    console.log(response);
    return response;
  };
}
